import React, { Component } from "react";

function API(props) {
  return <p>{props.dataObject}</p>;
}
export default API;
